import { render, staticRenderFns } from "./ModuleViewForm.vue?vue&type=template&id=de0cb97a"
import script from "./ModuleViewForm.vue?vue&type=script&lang=js"
export * from "./ModuleViewForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleViewForm.vue?vue&type=style&index=0&id=de0cb97a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports